<template>

    <div class="question-completion-witness">
        <svg v-if="!debuggr.completed" class="red-arrow" width="24px" height="18px" viewBox="0 0 24 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <polygon fill="#EC1D24" points="10 4 0 4 0 14 10 14 10 18 23 8.47058824 10 0"></polygon>
        </svg>
    </div>

</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    name: 'question-completion-witness',

    props: {
        uukey: String,
        scoreAndCompleted: Object,
    },

    beforeCreate()
    {
        const props = this.$options.propsData;
        if (props.uukey && props.scoreAndCompleted)
        {
            this.$store.commit('INIT_DEBUGGER_ANSWER', [props.uukey, props.scoreAndCompleted]);
        }
    },

    computed: {
        ...mapState({
            debuggr(state)
            {
                return state.debugger[this.uukey] || {};
            },
        }),
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/question-completion-witness.vue